import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ChatPage } from './Screens/ChatPage';
import { PrivacyPolicyPage } from './Screens/PrivacyPolicyPage';
import { ErrorBannerToast } from './Components/ErrorBanner/index';

const App: React.FC = () => {
   useEffect(() => {
      // Handle OAuth callback if this is a redirect from Google
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');

      if (code || error) {
         // Send message to parent window if this is a popup
         if (window.opener) {
            if (error) {
               window.opener.postMessage({
                  type: 'GOOGLE_OAUTH_ERROR',
                  error
               }, window.location.origin);
            } else if (code) {
               window.opener.postMessage({
                  type: 'GOOGLE_OAUTH_SUCCESS',
                  code,
                  state
               }, window.location.origin);
            }
            window.close();
         } else {
            // If not a popup, store the code for later use
            if (code) {
               localStorage.setItem('oauth_code', code);
               localStorage.setItem('oauth_state', state || '');
            }
            // Clean up the URL
            window.history.replaceState({}, document.title, window.location.pathname);
         }
      }
   }, []);

   return (
      <div className="h-[100dvh] app-root w-screen min-w-0 flex flex-col safe-area-md cx-canvas">
         <main className="flex flex-1 flex-col w-full min-w-0 min-h-0 h-full">
            <Routes>
               <Route path="/" element={<ChatPage />} />
               <Route path="/embed" element={<ChatPage />} />
               <Route path="/privacy" element={<PrivacyPolicyPage />} />
            </Routes>
         </main>
         <ErrorBannerToast />
      </div>
   );
};

export default App;
